import ScrollMagic from 'scrollmagic'
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'

const scrollController = new ScrollMagic.Controller()
export default scrollController
